import Damage from '@/models/Damage'
import DamageType from '@/models/DamageType';

class CombatService {
  constructor() {}

  /**
   * Source: https://exiledkingdoms.com/forum/index.php?threads/app-ek-companion.18581/post-66726
   * ((1-crit_chance)*(min+max)/2+crit_chance*(max+1+Floor[crit_mult*max])/2+extra_dmg)*speed/10
   * Source : https://www.exiledkingdoms.com/wiki/index.php?title=Template:DPS&action=edit
   * (100 - Crit) / 100 * (Min + Max) / 2 + Elem_Dam + ((((Max + 1) + (Max * Crit_Mult)) / 2) * (Crit / 100))) * (Speed / 10)) round 1
   */
  
  calculateFlatDamage(damage) {
    let sum = 0
    DamageType.ALL.forEach(damageType => {
      sum = sum + damage.getByDamageType(damageType)
    });
    return sum
  }

  calculateFlatDamagePerSecond(weapon) {
    return this.calculateFlatDamage(this.calculateDamagePerSecond(weapon))
  }

  calculateBaseDamagePerNormalHit(weapon) {
    return (weapon.baseDamageMin + weapon.baseDamageMax) / 2
  }

  calculateBaseDamagePerCriticalHit(weapon) {
    return (weapon.baseDamageMax + 1 + Math.floor(weapon.criticalMultiplicator * weapon.baseDamageMax)) / 2
  }

  calculateBaseDamagePerHit(weapon) {
    return (1 - weapon.criticalChance) * this.calculateBaseDamagePerNormalHit(weapon) + weapon.criticalChance * this.calculateBaseDamagePerCriticalHit(weapon)
  }

  calculateExtraDamagePerHit(weapon) {
    return weapon.extraDamage
  }

  calculateDamagePerSecond(weapon) {
    const damage = new Damage()
  
    const baseDamage = Math.round(this.calculateBaseDamagePerHit(weapon) * weapon.speed / 10 * 10) / 10
    damage.add(weapon.baseDamageType, baseDamage)
 
    const extraDamage = Math.round(this.calculateExtraDamagePerHit(weapon) * weapon.speed / 10 * 10) / 10
    damage.add(weapon.extraDamageType, extraDamage)

    return damage
  }

}

export default new CombatService();
